import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as BindingIcon } from 'assets/svgs/binding-icon.svg';
import { ReactComponent as HandshakeIcon } from 'assets/svgs/handshake-icon.svg';
import { ReactComponent as InfinitySymbol } from 'assets/svgs/infinity-symbol.svg';
import { Switch } from 'components/atoms/switch/switch';
import { PortalInputProps } from '../types';

interface CollaborationIconConfigProps extends PortalInputProps {
  onChange: (value: any) => void;
  value: unknown;
}

interface CollaborationIconConfig {
  isIconEnabled: boolean;
  iconType: string;
}

const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cp-spacing-02);
`;

export const CollaborationIconConfigWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--cp-spacing-03);
`;

const CollaborationIconsWrapper = styled.div`
  display: flex;
  gap: var(--cp-spacing-03);
`;

const IconWrapper = styled.div<{ isActive }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: var(--cp-grey-30);
  cursor: pointer;
  border: ${({ isActive }) =>
    isActive ? 'solid 2px #0F62FE' : 'solid 1px var(--cp-gray-30)'};

  .svg {
    position: relative;
    margin: auto;
  }
`;

enum CollaborationIconType {
  Binding = 'BINDING',
  Infinity = 'INFINITY',
  Handshake = 'HANDSHAKE',
}

const SmallIconWrapper = styled.span`
  top: 2px;
  position: relative;
  svg {
    width: 24px;
    height: 24px;
  }
`;

export const CollaborationIconMap = {
  [CollaborationIconType.Binding]: {
    smallIcon: (
      <SmallIconWrapper>
        <BindingIcon />
      </SmallIconWrapper>
    ),
    largeIcon: <BindingIcon />,
  },
  [CollaborationIconType.Infinity]: {
    smallIcon: (
      <SmallIconWrapper>
        <InfinitySymbol />
      </SmallIconWrapper>
    ),
    largeIcon: <InfinitySymbol />,
  },
  [CollaborationIconType.Handshake]: {
    smallIcon: (
      <SmallIconWrapper>
        <HandshakeIcon />
      </SmallIconWrapper>
    ),
    largeIcon: <HandshakeIcon />,
  },
};

export const CollaborationIconConfigPortalInput: React.FC<CollaborationIconConfigProps> =
  ({ onChange, value }) => {
    const CollaborationIconConfig: CollaborationIconConfig =
      value as CollaborationIconConfig;

    return (
      <CollaborationIconConfigWrapper>
        <SwitchWrapper>
          <Switch
            size="small"
            checked={CollaborationIconConfig?.isIconEnabled}
            onChange={(val) =>
              onChange({ ...CollaborationIconConfig, isIconEnabled: val })
            }
          />
          <FormattedMessage id="collaboration_icon_config.show_collaboration_icons" />
        </SwitchWrapper>
        <CollaborationIconsWrapper>
          {CollaborationIconConfig?.isIconEnabled &&
            Object.keys(CollaborationIconMap).map((iconKey) => {
              return (
                <IconWrapper
                  data-cy={`cp.collaboration_icon_config_input.${iconKey}`}
                  isActive={CollaborationIconConfig.iconType === iconKey}
                  key={iconKey}
                  onClick={() =>
                    onChange({
                      ...CollaborationIconConfig,
                      iconType: iconKey,
                    })
                  }
                >
                  {CollaborationIconMap[iconKey].smallIcon}
                </IconWrapper>
              );
            })}
        </CollaborationIconsWrapper>
      </CollaborationIconConfigWrapper>
    );
  };
